export interface PageListItemModel {
    pageTitle: string;
    path: string;
    extra: string;
    desc?: string;
}

export const homePageList: PageListItemModel[] = [
    {
        pageTitle: '一月',
        path: '/january',
        extra: 'Jan',
    },
    {
        pageTitle: '二月',
        path: '/february',
        extra: 'Feb',
    },
    {
        pageTitle: '三月',
        path: '/march',
        extra: 'Mar',
    },
    {
        pageTitle: '四月',
        path: '/april',
        extra: 'Apr',
    },
    {
        pageTitle: '五月',
        path: '/may',
        extra: 'May',
    },
    {
        pageTitle: '六月',
        path: '/june',
        extra: 'Jun',
    },
    {
        pageTitle: '七月',
        path: '/july',
        extra: 'Jul',
    },
    {
        pageTitle: '八月',
        path: '/august',
        extra: 'Aug',
    },
    {
        pageTitle: '九月',
        path: '/september',
        extra: 'Sept',
    },
    {
        pageTitle: '十月',
        path: '/october',
        extra: 'Oct',
    },
    {
        pageTitle: '十一月',
        path: '/november',
        extra: 'Nov',
    },
    {
        pageTitle: '十二月',
        path: '/december',
        extra: 'Dec',
    },
];

export const adminAccountList: string[] = ['yyds', 'YYDS'];
